<template>
  <page title="Billing Report Settings" :loading="loading" backURI=":back">
    <template #body>
      <div class="settings-columns">
        <div class="settings-column">
          <div class="section">All Accounts Report</div>
          <div class="form">
            <div class="input-group">
              <div class="input-group">
                <dropdown
                  label="System"
                  v-model="system"
                  :list="systemsList"
                  :options="{ searchMode: 'none' }"/>
              </div>

              <div class="input-group">
                <dropdown
                  label="Month of Reference"
                  v-model="monthOfReference"
                  :list="monthOfReferenceList"
                  :options="{ searchMode: 'none' }"/>
              </div>

              <div class="input-group info">
                <p>This report is generated asynchronously. Please, provide a list of e-mails to receive the report when it's finished.</p>
              </div>

              <div class="input-group">
                <editable-list v-model="emails" placeholder="Type an e-mail"/>
              </div>

              <div class="input-group">
                <info-box type="success" :text="requestInfobox"/>
              </div>

              <div class="input-group bottom">
                <form-button @click="requestAllAccountsReport">Request Report</form-button>
              </div>
            </div>
          </div>
        </div>

        <div class="settings-column">
          <div class="section">Automatic Monthly Billing Report</div>
          <div class="form">
            <div class="input-group">
              <div class="input-group">
                <p class="hint">Set a list of e-mails to receive an automatic monthly report with all billing accounts</p>

                <editable-list
                  v-model="monthlyReportRecipients"
                  type="email"
                  label="Recipients"
                  placeholder="Type an e-mail"
                />
              </div>

              <info-box :text="infoBoxText"/>

              <div class="input-group bottom">
                <form-button @click="save">Save</form-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page.vue'
import EditableList from '@/components/EditableList.vue'
import FormButton from '@/components/FormButton.vue'
import InfoBox from '@/components/InfoBox.vue'
import Dropdown from '@/components/Dropdown.vue'

import gql from 'graphql-tag'

export default {
  name: 'BillingConfigsView',

  components: {
    Page,
    EditableList,
    FormButton,
    InfoBox,
    Dropdown
  },

  methods: {
    getConfigs () {
      this.loading = true

      this.$apollo.query({
        query: gql`
          query {
            billing {
              configs: getConfigs {
                monthlyReportRecipients
              }
            }
          }
        `,
        fetchPolicy: 'no-cache'
      }).then(data => {
        this.monthlyReportRecipients = data.data.billing.configs.monthlyReportRecipients
      }).finally(() => {
        this.loading = false
      })
    },

    save () {
      this.$apollo.mutate({
        mutation: gql`
          mutation ($data: BillingConfigInput!) {
            billing {
              setConfigs (data: $data)
            }
          }
        `,
        variables: {
          data: {
            monthlyReportRecipients: this.monthlyReportRecipients
          }
        }
      }).then(() => {
        this.infoBoxText = '::success Preferences successfully saved!'
      })
    },

    requestAllAccountsReport () {
      this.$apollo.query({
        query: gql`
          query ($systemId: String!, $emails: [String]!, $monthOfReference: String!) {
            billing {
              requestAllAccountsBillingReport(systemId: $systemId, emails: $emails, monthOfReference: $monthOfReference)
            }
          }
        `,
        variables: {
          systemId: this.system.value,
          monthOfReference: this.monthOfReference.value,
          emails: this.emails
        },
        fetchPolicy: 'no-cache'
      }).then(() => {
        this.requestInfobox = "Your report has been successfully requested. Please, wait while it's being processed. You will receive an e-mail when it's finished"
      })
    }
  },

  computed: {
    monthOfReferenceList () {
      const currentDate = new Date()
      const monthName = currentDate.toLocaleString('en-US', { month: 'long', year: 'numeric' })

      return [
        {
          label: `${monthName} (Current)`,
          value: currentDate.toISOString().substring(0, 7)
        }
      ]
    }
  },

  data () {
    return {
      infoBoxText: null,
      requestInfobox: null,
      loading: true,
      monthlyReportRecipients: [],
      all: false,
      system: {
        label: 'TireView',
        value: 'default'
      },
      monthOfReference: null,
      systemsList: [
        {
          label: 'TireView',
          value: 'default'
        },
        {
          label: 'Goodyear',
          value: 'goodyear'
        }
      ],
      emails: [this.$store.state.auth.user.email]
    }
  },

  mounted () {
    this.getConfigs()
  }
}
</script>

<style lang="less" scoped>
.settings-columns {
  display: flex;
  gap: 100px;
  align-items: flex-start;
}

.settings-column {
  flex: 1;
  min-width: 0;
}

.section {
  margin-bottom: 15px;
  color: contrast(@main-color);
  font-family: Rajdhani, sans-serif;
  font-size: 18pt;
}

.hint {
  font-style: italic;
  margin: 10px 0;
  opacity: 0.5;
  font-size: 10pt;
  color: @accent-color;
}

.info {
  padding: 10px;
  background: fade(@accent-color, 5%);
  color: @accent-color;
  border-radius: 10px;
}

@media (max-width: 900px) {
  .settings-columns {
    flex-direction: column;
    gap: 30px;
  }
}
</style>
